import { AddressCollectionSchema } from "@redotech/redo-model/address-collection";
import * as z from "zod/v4";

export const getAddressesByIds = {
  name: "getAddressesByIds" as const,
  input: z.object({ ids: z.array(z.string()) }),
  output: z.object({ addresses: z.array(AddressCollectionSchema) }),
};
